/**
 * KAN-717: флажок "Прикладывать к письму" для материала оператора.
 * Общий для формы добавления и строки списка.
 */
import { MaterialFlagCheckbox } from './MaterialFlagCheckbox';

interface AttachToEmailCheckboxProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Дополнение к подписи для доступного имени (название материала в строке списка). */
  ariaLabel?: string;
}

export function AttachToEmailCheckbox(props: AttachToEmailCheckboxProps): JSX.Element {
  return (
    <MaterialFlagCheckbox
      {...props}
      label="Прикладывать к письму"
      hint="файл уйдёт вложением во вводном письме клиенту"
    />
  );
}
